<template>
  <div class="flex md:items-center justify-center lg:h-screen">
    <div class="xxs:max-w-[320px] xxs:py-6 lg:py-0 lg:max-w-[480px] mx-auto md:h-fit h-full relative rounded-[20px] background-shadow flex flex-col items-center justify-center">
        <div v-if="organization" class="flex flex-col justify-start items-start mb-6 w-full">
            <img v-if="organization.theme_settings && organization.theme_settings.logo"
                 :src="useImagePathFormatter(organization.slug, organization.theme_settings.logo)"
                 class="object-contain w-20 h-20 rounded-full mb-4"
                 alt="logo"
            />
          <h2 class="text-left lg:text-body-1 md:text-body-2 text-body-3 font-medium text-white">
            Welcome to {{ organization.name }}!
          </h2>
        </div>
        <div v-else class="flex flex-row justify-between items-center mb-6">
          <h2 class="text-left lg:text-body-1 md:text-body-2 text-body-3 font-medium text-white">
            Welcome to Connect Plus+
          </h2>
          <DefaultOrgIcon :color="defaultIconColor" />
        </div>
      <div :class="registerForOrganization && 'mb-10 w-full'">
        <p class="text-body-3 text-default-3 font-normal">Sign up by entering the information below.<br>All the fields are required</p>
      </div>

      <div class="lg:my-12 my-8" v-if="!registerForOrganization">
        <Stepper :steps="steps"/>
      </div>

      <div>
        <component :is="signUpStore.step" :colorMode="colorMode"></component>
      </div>

    </div>
  </div>
</template>

<script setup>
import Stepper from '@/components/core/Stepper.vue';
import {computed, ref} from "vue";
import {useSignUp} from "@/stores/SignUpStore";
import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";
import {useImagePathFormatter} from "@/composables/useImagePathFormatter";
import DefaultOrgIcon from "@/components/icons/small/DefaultOrgIcon.vue";
import {useTheme} from "@/stores/ThemeStore";

const colorMode = 'dark'

const {color} = storeToRefs(useTheme());
const {getContrastingColor} = useTheme();

const STATUS_COMPLETE = 'complete';
const STATUS_CURRENT = 'current';
const STATUS_UPCOMING = 'upcoming';

const signUpStore = useSignUp();
const {organization} = storeToRefs(useAuth());

const firstStepStatus = computed(() => {
    if (signUpStore.currentStep === 0) {
        return STATUS_CURRENT
    }

    if (signUpStore.currentStep > 0) {
        return STATUS_COMPLETE;
    }

    return STATUS_UPCOMING;
});

const secondStepStatus = computed(() => {
    if (signUpStore.currentStep === 1) {
        return STATUS_CURRENT;
    }

    if (signUpStore.currentStep > 1) {
        return STATUS_COMPLETE;
    }

    return STATUS_UPCOMING;
});

const steps = ref([
    {
        name: 'Basic info',
        status: firstStepStatus.value
    },
    {
        name: 'Selection of organization',
        status: secondStepStatus.value
    },
]);


const registerForOrganization = computed(() => {
    return organization.value !== null;
});

const defaultIconColor = computed(() => {
    return {hex: getContrastingColor(color.value.hex)};
})

</script>
